import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from './plugins/vuetify';
import VueGlobalVariable from "vue-global-var";
Vue.use(VueAxios, axios);
Vue.config.productionTip = false
Vue.use(VueGlobalVariable, {
  globals: {
    base_url: 'https://invoicer.grupowapps.es'
  }
});
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
